import { render } from "./upcoming_expire.vue?vue&type=template&id=3a30a252"
import script from "./upcoming_expire.vue?vue&type=script&lang=js"
export * from "./upcoming_expire.vue?vue&type=script&lang=js"

import "./upcoming_expire.vue?vue&type=style&index=0&id=3a30a252&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__